import { LinkButton } from 'components/common';
import { useReduxState } from 'hooks';

interface Props {
  href: string;
  numberOfItems?: number;
}

const PageShowAllLink = ({ href, numberOfItems }: Props) => {
  const { messages } = useReduxState();

  return (
    <div className="show-all">
      <LinkButton
        category="light"
        href={href}
        isRounded={true}
        text={
          messages.commonShowAll + (numberOfItems ? ` ${numberOfItems}` : '')
        }
      />

      <style jsx>{`
        .show-all {
          display: flex;
          justify-content: center;
          margin-top: 20px;
          width: 100%;
        }
      `}</style>
    </div>
  );
};

export default PageShowAllLink;
